module.exports = __webpack_public_path__ + "static/img/services-content-03.fa7e797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services-content-03.jpg
// module id = LZrg
// module chunks = 0